import { useState, useCallback } from 'react';

import { localStorageService } from '../../utils/localStorage';
import { useIsHydrated } from '../../hooks';

/**
 * Хук для управления видимостью баннера
 * Сохраняет состояние закрытия в localStorage по переданному ключу
 */
export const useBannerVisibility = (storageKey: string) => {
    const isHydrated = useIsHydrated();

    const [isVisible, setIsVisible] = useState(() => {
        return !localStorageService.exists(storageKey);
    });

    const handleClose = useCallback(
        (e?: React.MouseEvent) => {
            e?.preventDefault();
            e?.stopPropagation();

            localStorageService.save(storageKey, true);
            setIsVisible(false);
        },
        [storageKey],
    );

    return { isVisible: isHydrated && isVisible, handleClose };
};
